import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    background: '#fff',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, .29)',
  },
  item: {
    padding: '10px 20px',
    cursor: 'pointer',
    '&:hover': {
      background: '#eee',
    },
  },
  activeItem: {
    background: '#eee',
    cursor: 'default',
    '&:hover': {
      background: '#fff',
    },
  },
  cooperativeName: {
    fontSize: 15,
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  inputWrapper: {
    padding: '5px 15px',
    background: 'rgba(0,0,0,.05)',
  },
  inputRoot: {
    width: '100%',
    paddingLeft: 5,
    paddingRight: 5,
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    fontWeight: 400,
    border: '1px solid #c3c3c3',
  },
  textFieldRoot: {
    width: '100%',
  },
}));
